export default __webpack_public_path__ + "static/media/tt11.49a9b1af.png";